module.exports = __webpack_public_path__ + "static/media/edit_pencil.e500a697.svg";